// import { createSelector } from 'reselect';

export const getOldPassword = state => state.getIn(['resetPasswordWithOldPassword', 'oldPassword']);
export const getNewPassword = state => state.getIn(['resetPasswordWithOldPassword', 'newPassword']);
export const getConfirmPassword = state => state.getIn(['resetPasswordWithOldPassword', 'confirmPassword']);
export const getIsReset = state => state.getIn(['resetPasswordWithOldPassword', 'isReset']);
export const getErrMessage = state => state.getIn(['resetPasswordWithOldPassword', 'errMessage']);

